import {CompanyType} from '../helpers/index';

export class Company {
    companyId: number;
    companyName: string;
    //companyAddress: string;
    companyType: CompanyType;
    streetAddress: string;
    suiteRoomBuilding: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    logoFileName: string;
}
